import moment from "moment";
import { getAge } from "./shared";

export const STANDARD_MINIMUM_VALUE = 0;
export const STANDARD_MAXIMUM_VALUE = 1000000000;
export const MAX_TEXT_SIZE = 255;
export const MIN_TEXT_SIZE = 0;

export const isTextBoxNonEmpty = (text, max_text_size, min_text_size) => {
  if (!max_text_size) max_text_size = MAX_TEXT_SIZE;
  if (!min_text_size) min_text_size = MIN_TEXT_SIZE;
  if (text === null) return false;
  if (text.length > max_text_size) return false;
  if (text.length < min_text_size) return false;
  return text !== "";
};

export const isEmailValid = (email) => {
  if (!isTextBoxNonEmpty(email)) return false;
  let re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const isEmailListValid = (emailList) => {
  if (emailList == null || emailList.length === 0) return null;
  const result = emailList.map(email => {
    return isEmailValid(email.emailAddress);
  });
  return result;
};

export const validResultList = (list) => {
  if (list == null || list.length === 0) return false;
  let result = true;
  list.forEach(item => {
    if (item === false) result = false;
  });
  return result;
};

export const isPasswordValid = (password, max_text_size) => {
  if (!isTextBoxNonEmpty(password, max_text_size)) return false;
  return password !== "";
};

export const isNumericTextboxValid = (value, minimum, maximum) => {
  if (!minimum) minimum = STANDARD_MINIMUM_VALUE;
  if (!maximum) maximum = STANDARD_MAXIMUM_VALUE;
  if (value === "" || value === null) return false;

  value = parseFloat(value);
  return !(value < minimum || value > maximum);
};

export const isPhoneNumberValid = (phoneNumber, fullyValid) => {
  if (phoneNumber === "___-___-____" || phoneNumber === "") return fullyValid ? false : true;
  // var formats = "(999)999-9999|999-999-9999|9999999999";
  var formats = "999-999-9999";
  var r = RegExp(
    "^(" + formats.replace(/([\(\)])/g, "\\$1").replace(/9/g, "\\d") + ")$"
  );
  return r.test(phoneNumber);
};

export const isPhoneNumberListValid = (phoneNumberList) => {
  if (phoneNumberList == null || phoneNumberList.length === 0) return null;
  const result = phoneNumberList.map(phoneNumber => {
    return isPhoneNumberValid(phoneNumber.phoneNumber);
  });
  return result;
};

export const isValidCreditCardExpiratoryDate = (value) => {
  if (value === "" || value === null) return false;
  const exMonth = parseInt(value.substring(0, 2));
  if (exMonth === 0 || exMonth > 12) return false;
  const exYear = parseInt("20" + value.substring(3));
  const today = new Date();
  let someday = new Date();
  someday.setFullYear(exYear, exMonth, 0);

  if (someday < today) {
    return false;
  } else {
    return true;
  }
};

export const formObjectValidator = (formObj) => {
  for (let prop in formObj) {
    if (!formObj.hasOwnProperty(prop)) continue;
    if (!formObj[prop].isValid) return false;
  }
  return true;
};

export const validateBillingInformation = (billingInformation) => {
  return {
    firstName: {
      value: billingInformation.firstName.value,
      isValid: isTextBoxNonEmpty(billingInformation.firstName.value),
    },
    lastName: {
      value: billingInformation.lastName.value,
      isValid: isTextBoxNonEmpty(billingInformation.lastName.value),
    },
    address: {
      value: billingInformation.address.value,
      isValid: isTextBoxNonEmpty(billingInformation.address.value),
    },
    city: {
      value: billingInformation.city.value,
      isValid: isTextBoxNonEmpty(billingInformation.city.value),
    },
    state: {
      value: billingInformation.state.value,
      isValid: isTextBoxNonEmpty(billingInformation.state.value),
    },
    zipCode: {
      value: billingInformation.zipCode.value,
      isValid: isNumericTextboxValid(billingInformation.zipCode.value),
    },
    email: {
      value: billingInformation.email.value,
      isValid: isEmailValid(billingInformation.email.value),
    },
    phone: {
      value: billingInformation.phone.value,
      isValid: isPhoneNumberValid(billingInformation.phone.value),
    },
  };
};

export const validateCreditCardInformation = (creditCardInformation) => {
  return {
    creditCardType: {
      value: creditCardInformation.creditCardType.value,
      isValid: isTextBoxNonEmpty(creditCardInformation.creditCardType.value),
    },
    creditCardNumber: {
      value: creditCardInformation.creditCardNumber.value,
      isValid: isTextBoxNonEmpty(creditCardInformation.creditCardNumber.value),
    },
    expiratoryDate: {
      value: creditCardInformation.expiratoryDate.value,
      isValid: isValidCreditCardExpiratoryDate(
        creditCardInformation.expiratoryDate.value
      ),
    },
    cvv: {
      value: creditCardInformation.cvv.value,
      isValid: isNumericTextboxValid(creditCardInformation.cvv.value),
    },
  };
};

export const limitCharacters = (input, characterLimit) => {
  if (input.length > characterLimit) return input.substr(0, characterLimit);
  return input;
};

export const validateFeeModel = (feeModel) => {
  return {
    feeModelName: {
      value: feeModel.feeModelName.value,
      isValid: isTextBoxNonEmpty(feeModel.feeModelName.value),
    },
    reduceReturn: {
      value: feeModel.reduceReturn.value,
      isValid: true,
    },
    blendedRate: {
      value: feeModel.blendedRate.value,
      isValid: isNumericTextboxValid(feeModel.blendedRate.value, 0, 1),
    },
    minimumAmount: {
      value: feeModel.minimumAmount.value,
      isValid: isNumericTextboxValid(feeModel.minimumAmount.value, 0),
    },
    flatFee: {
      value: feeModel.flatFee.value,
      isValid: isNumericTextboxValid(feeModel.flatFee.value, 0),
    },
  };
};

export const validateClientAndCoClient = (data) => {
  const logicalValidationLifeExpectancy = () => {
    let dob = moment(data.dateOfBirth.value);
    let age = moment().diff(dob, "years");
    if (!isNumericTextboxValid(data.lifeExpectancy.value, 1, 200)) {
      return false;
    } else if (
      age > data.lifeExpectancy.value ||
      data.lifeExpectancy.value > 200
    ) {
      console.log(
        "Life expectancy lesser than age upi= age=>" +
          age +
          " life expect= " +
          dob
      );
      return false;
    } else {
      return true;
    }
  };

  const logicalValidationRetirementAge = () => {
    let dob = moment(data.dateOfBirth.value);
    if (!isNumericTextboxValid(data.retirementAge.value, 1, 200)) {
      return false;
    } else if (
      data.retirementAge.value > data.lifeExpectancy.value ||
      data.retirementAge.value > 200
    ) {
      console.log(
        "Life expectancy lesser than retirement age upi=retire=>" +
          data.retirementAge.value +
          " life= " +
          data.lifeExpectancy.value
      );
      return false;
    } else {
      return true;
    }
  };

  return {
    ...data,
    firstName: {
      value: data.firstName.value,
      isValid: isTextBoxNonEmpty(data.firstName.value, 30),
    },
    lastName: {
      value: data.lastName.value,
      isValid: isTextBoxNonEmpty(data.lastName.value, 30),
    },
    dateOfBirth: {
      value: data.dateOfBirth.value,
      isValid: data.dateOfBirth.value ? !isNaN(new Date(data.dateOfBirth.value).getTime()) : false
    },
    retirementAge: {
      value: data.retirementAge.value,
      isValid: data.dateOfBirth.value ? logicalValidationRetirementAge() : isNumericTextboxValid(data.retirementAge.value, 1, 200),
    },
    lifeExpectancy: {
      value: data.lifeExpectancy.value,
      isValid: data.dateOfBirth.value ? logicalValidationLifeExpectancy() : isNumericTextboxValid(data.lifeExpectancy.value, 1, 200),
    },
  }
};

export const validateMember = (data) => {
  return {
    ...data,
    firstName: {
      value: data.firstName.value,
      isValid: isTextBoxNonEmpty(data.firstName.value, 30),
    },
    lastName: {
      value: data.lastName.value,
      isValid: isTextBoxNonEmpty(data.lastName.value, 30),
    },
    dateOfBirth: {
      value: data.dateOfBirth.value,
      isValid: data.dateOfBirth.value ? !isNaN(new Date(data.dateOfBirth.value).getTime()) : false
    }
  };
};

export const validateDateOfBirth = (dateOfBirth) =>
{
  if (!dateOfBirth) return false;
  return !isNaN(new Date(dateOfBirth.getTime()));
}

export const isPositiveInteger = (value) => {
  const minimum = 0;
  const maximum = STANDARD_MAXIMUM_VALUE;
  if (value === ""
      || value === null
      || !Number.isInteger(value))
    return false;

  value = parseFloat(value);
  return !(value < minimum || value > maximum);
};


export const isDatePriorToTodaysMonth = date=>{
  const d = new Date()
  const today = new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
  return (date < today)
}

export const isDateFurtherThanLifeExpectancy = (date, dateOfBirth, lifeExpectancy)=>{
  const d = new Date()
  const currentAge = getAge(dateOfBirth)
  const yearsAhead = lifeExpectancy - currentAge
  const dOB = new Date(dateOfBirth)
  const extraYearWithSameAge = dOB.getMonth()===0?0:1
  const limitMonth = dOB.getMonth()===0?11:d.getMonth()-1
  const limitDate = new Date(d.getFullYear() + yearsAhead + extraYearWithSameAge, limitMonth, 1, 0, 0, 0, 0);
  const inputDate = new Date(date)
  return (inputDate > limitDate)
}